import { ace_index } from '@axo/shared/data-access/types';
import { classNames } from '../../utils/classNames';
import { IconButton } from '../IconButton';
import styles from './SearchResults.module.css';

interface Props {
  current: ace_index.FindSort[];
  setCurrent: (s: ace_index.FindSort[]) => void;
  config: ace_index.SortBy | ace_index.SortBy[];
}

export function SortIcon({ current, setCurrent, config }: Props) {
  const primarySortBy = Array.isArray(config) ? config[0] : config;

  const index = current.findIndex(
    (sort) =>
      sort.SortBy.Table === primarySortBy.Table &&
      sort.SortBy.Column === primarySortBy.Column,
  );

  const isApplied = index !== -1;

  return (
    <IconButton
      icon={
        isApplied && current[index]?.Order === ace_index.Order.Ascending
          ? 'chevron-up'
          : 'chevron-down'
      }
      onClick={() => {
        const order = isApplied
          ? flip(current[index].Order)
          : ace_index.Order.Descending;

        const sortEntries = Array.isArray(config) ? config : [config];

        setCurrent(
          sortEntries.map((sortBy) => ({
            SortBy: sortBy,
            Order: order,
          })),
        );
      }}
      classes={{
        icon: classNames(styles.sortIcon, isApplied && styles.boldIcon),
      }}
    />
  );
}

function flip(order: ace_index.Order): ace_index.Order {
  return order === ace_index.Order.Descending
    ? ace_index.Order.Ascending
    : ace_index.Order.Descending;
}
